import { ScreenshotLegendPlacement } from "./enums/screenshot-legend-placement";

export class VenueAdminRoom {
  roomId: number;
  roomName: string;
  primaryImageUrl: string;
  maxCapacity: number;
  distanceBetweenChairsInches: number;
  allowsChandeliers: boolean;
  displayIconLegendInScreenshots: boolean;
  screenshotLegendPlacement: ScreenshotLegendPlacement;
}
